/* eslint-disable consistent-return */
import { produce } from 'immer'

import { Redux } from 'types/local'
import { Enum } from 'types/enum'
import { projectDetailActions } from './project-detail.actions'

const { types } = projectDetailActions

export type State = Redux.UserState['projectDetail']
export const initialState: State = {
  project: null,
  isLoading: false,
  jackpot: [],
  totalGames: {
    jackpot: 0,
    ticket: 0,
  },
  totalParticipant: {
    jackpot: 0,
    ticket: 0,
  },
  statistic: [],
}
export const projectDetailReducer = produce((state: State, action: Redux.Action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case types.GET_PROJECT_DETAIL.REQUEST:
      state.isLoading = true
      break
    case types.GET_PROJECT_DETAIL.SUCCESS:
      state.isLoading = false
      state.project = action.payload
      break
    case types.GET_PROJECT_DETAIL.FAILED:
      state.isLoading = false
      break
    case types.GET_PROJECT_MEGA_JACKPOT.REQUEST:
      state.isLoading = true
      break
    case types.GET_PROJECT_MEGA_JACKPOT.SUCCESS:
      state.isLoading = false
      state.jackpot = action.payload
      state.totalGames.jackpot = action.payload[0] ? action.payload[0].createdGames.length : 0
      break
    case types.GET_PROJECT_MEGA_JACKPOT.FAILED:
      state.isLoading = false
      break
    case types.GET_PROJECT_PARTICIPANT.REQUEST:
      state.isLoading = true
      break
    case types.GET_PROJECT_PARTICIPANT.SUCCESS:
      state.isLoading = false
      state.totalParticipant.jackpot = action.payload
      break
    case types.GET_PROJECT_PARTICIPANT.FAILED:
      state.isLoading = false
      break
    case types.GET_PROJECT_STATISTIC.REQUEST:
      state.isLoading = true
      break
    case types.GET_PROJECT_STATISTIC.SUCCESS:
      state.isLoading = false
      state.statistic = action.payload
      break
    case types.GET_PROJECT_STATISTIC.FAILED:
      state.isLoading = false
      break
    case types.RESET_STATE:
      return initialState
  }
}, initialState)
